import {
  MessageSquareWarning,
  LayoutDashboard, Users, UserPlus, Send, FileText, Calendar, QrCode, Package,
  HeartHandshake, Gavel, Handshake, Landmark, BarChart3, ShieldCheck, Settings,
  Trash2, RotateCcw, IdCard, HandHeart, Gift, CreditCard, User, CheckSquare,
  ListTodo, Search, Bell, Download, LogOut, ChevronDown, Plus, Circle, Eye,
  Sprout, UserMinus, Clock, LayoutGrid, Blocks, Boxes, ShoppingBag, MessageSquare,
  Plug, ToggleRight, Image, SlidersHorizontal, Receipt, HandCoins, ScrollText, Filter,
  TicketPercent, KeyRound, ShieldAlert, Check, X, ChevronRight, Cake, Link2, Ban, RefreshCw,
  Upload, HardDrive, CheckCircle2, MapPin, Video, ExternalLink, Award, MoreHorizontal,
  Maximize2, Minimize2, ChevronLeft, ClipboardList, AlertTriangle, Megaphone, Phone, Mail, Contact,
} from "lucide-react";

export const ICONS = {
  MessageSquareWarning,
  LayoutDashboard, Users, UserPlus, Send, FileText, Calendar, QrCode, Package,
  HeartHandshake, Gavel, Handshake, Landmark, BarChart3, ShieldCheck, Settings,
  Trash2, RotateCcw, IdCard, HandHeart, Gift, CreditCard, User, CheckSquare,
  ListTodo, Search, Bell, Download, LogOut, ChevronDown, Plus, Circle, Eye,
  Sprout, UserMinus, Clock, LayoutGrid, Blocks, Boxes, ShoppingBag, MessageSquare,
  Plug, ToggleRight, Image, SlidersHorizontal, Receipt, HandCoins, ScrollText, Filter,
  TicketPercent, KeyRound, ShieldAlert, Check, X, ChevronRight, Cake, Link2, Ban, RefreshCw,
  Upload, HardDrive, CheckCircle2, MapPin, Video, ExternalLink, Award, MoreHorizontal,
  Maximize2, Minimize2, ChevronLeft, ClipboardList, AlertTriangle, Megaphone, Phone, Mail, Contact,
};

export function Icon({ name, ...props }) {
  const Cmp = ICONS[name] || Circle;
  return <Cmp {...props} />;
}
